import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import ProductCard from './ui/ProductCard';
import { useTranslation } from 'react-i18next';

export const LoanProduct = ({ rates, products }) => {
    const { getValues, setValue } = useFormContext();
    const [selected, setSelected] = useState('');
    const [promos, setPromos] = useState([]);
    const values = getValues();
    const { t, i18n } = useTranslation();

    const handelProductClick = (product, type, isPromo, id) => (e) => {
        //rest form
        restLoanValues();
        setValue('loan.type', type);
        setValue('loan.product.id', id);
        setValue('loan.product.title', product);
        setValue('loan.product.isPromo', isPromo);
        setSelected(product);
    };

    const restLoanValues = () => {
        setValue('loan.amount', '');
        setValue('loan.amortization', '');
        setValue('loan.frequency', '');
        setValue('loan.term', '');
        setValue('loan.payment', 0);
        setValue('loan.purpose', '');
        setValue('loan.interestRate', 0);
    };

    useEffect(() => {
        setSelected(values?.loan?.product?.title);
    }, [values?.loan?.product?.title]);

    useEffect(() => {
        if (rates) {
            const promos = rates.filter((a) => a.isPromo === true);
            if (promos) setPromos(promos);
        }
    }, [rates]);

    let cssGridCols = 'md:grid-cols-4';
    switch (products?.length) {
        case 2:
            cssGridCols = 'md:grid-cols-2';
            break;
        case 3:
            cssGridCols = 'md:grid-cols-3';
            break;
        default:
            cssGridCols = 'md:grid-cols-4';
            break;
    }

    return (
        <div name="LoanProducts">
            <div className={`grid gap-4 sm:grid-cols-2 ${cssGridCols}`}>
                {products.map((p, index) => {
                    return (
                        <div key={index}>
                            <ProductCard
                                id={0}
                                type={p.value}
                                title={t('products.' + p.value)}
                                selected={selected === t('products.' + p.value)}
                                onProductClick={handelProductClick}
                            />
                        </div>
                    );
                })}
                {promos.length > 0 ? (
                    <>
                        {promos.map((p, index) => {
                            return (
                                <div key={index}>
                                    <ProductCard
                                        type={p.type}
                                        title={i18n.language === 'fr' && p.descFr !== '' ? p.descFr : p.desc}
                                        selected={selected === p.desc || selected === p.descFr}
                                        onProductClick={handelProductClick}
                                        isPromo={true}
                                        id={p.rateid}
                                    />
                                </div>
                            );
                        })}
                    </>
                ) : null}
            </div>
        </div>
    );
};
